import i18n from "@/i18n";
import {
  FilterBy,
  FilterBySerializer,
  OptionsTable,
  QueryTable,
  SortBySerializer,
  TableConfig,
} from "@/models/table";

export interface AdminUser {
  userId?: string;
  companyUserInvitationId?: string;
  email: string;
  firstName: string;
  lastName: string;
  creationDate: Date;
  status: string;
}
/* eslint-disable-next-line  @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types */
export function AdminUserDeserializer(input: any): AdminUser {
  return {
    userId: input.userId,
    companyUserInvitationId: input.companyUserInvitationId,
    email: input.email,
    firstName: input.firstName,
    lastName: input.lastName,
    creationDate: new Date(input.creationDate),
    status: input.status,
  };
}

export const adminUserConfig: TableConfig = {
  userId: {
    dtoName: "userId",
    sortable: false,
    filterable: false,
    label: i18n.t("common.id"),
    hideColumn: true,
  },
  email: {
    dtoName: "email",
    sortable: true,
    filterable: true,
    label: i18n.t("common.email"),
    hideColumn: false,
  },
  firstName: {
    dtoName: "firstName",
    sortable: true,
    filterable: true,
    label: i18n.t("common.firstname"),
    hideColumn: false,
  },
  lastName: {
    dtoName: "lastName",
    sortable: true,
    filterable: true,
    label: i18n.t("common.lastname"),
    hideColumn: false,
  },
  status: {
    dtoName: "status",
    sortable: true,
    filterable: true,
    label: i18n.t("common.status"),
    hideColumn: false,
  },
} as TableConfig;

export function AdminUserSearchSerializer(
  options: OptionsTable,
  searchString?: string,
  additionalFilters?: FilterBy[]
): QueryTable {
  return {
    limit: options.itemsPerPage,
    page: options.page,
    sortBy: SortBySerializer(options, adminUserConfig),
    filterBy: {
      values: FilterBySerializer(
        adminUserConfig,
        searchString,
        additionalFilters
      ),
    },
  };
}
